var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSdIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1953 40.0813V35.51",
    stroke: "#0e131c",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 40.0812V30.9387",
    stroke: "#0e131c",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8086 40.0813V26.3455",
    stroke: "#0e131c",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8047 12.9187L36.7889 14.1112C31.1577 20.692 23.6052 25.3516 15.1914 27.4495",
    stroke: "#0e131c",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3359 12.9187H37.8064V19.367",
    stroke: "#0e131c",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8763 48.5834H33.1263C44.168 48.5834 48.5846 44.1668 48.5846 33.1251V19.8751C48.5846 8.83342 44.168 4.41675 33.1263 4.41675H19.8763C8.83464 4.41675 4.41797 8.83342 4.41797 19.8751V33.1251C4.41797 44.1668 8.83464 48.5834 19.8763 48.5834Z",
    stroke: "#0e131c",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdIcon01);
export default __webpack_public_path__ + "static/media/sd-icon01.28652652cc2c720fe5129be4d609dedd.svg";
export { ForwardRef as ReactComponent };